import React from "react";

import { AdminHead, AdminSection, MainPage } from "components";

import { CropExplorationContextProvider } from "pages/app/crop-explorer/CropExplorationContext";
import { CropExplorerTabs } from "pages/app/crop-explorer/components/CropExplorerTabs";

export const CropExplorer = () => (
  <CropExplorationContextProvider isAdmin>
    <MainPage pageName={"admin"}>
      <AdminHead headline="Crop Explorer" description="View, add or update crop explorer config." />
      <AdminSection headline="Pre-loaded sample crop rotations" />
      <CropExplorerTabs isAdmin />
    </MainPage>
  </CropExplorationContextProvider>
);
